import { useAppSelector, useAppDispatch } from "@/services/hooks";
import React, { useEffect, useMemo } from "react";

import { ToastContainer } from "react-toastify";
import { Link } from "react-router";
import { Button, Media } from "reactstrap";
import {
  getProductAds,
  getProductById,
} from "@/services/productServices/productActions";
import DisplayAdsView from "./DisplayAdsView";
import withRouter from "@/utils/withRouter";

/** A product ad from `products.ads`, as the columns below read it. */
type AdRow = {
  _id: string;
  adsMedia?: string;
  adsTitle?: string;
  adsDescription?: string;
  adsPosition?: string;
};

type AdCellProps = { row: { original: AdRow } };

export type DisplayAdsContainerProps = {
  // injected by withRouter
  router?: { params?: { id?: string } };
};

function DisplayAdsContainer({ router }: DisplayAdsContainerProps) {
  const dispatch = useAppDispatch();
  const ads: AdRow[] = useAppSelector((s) => s.products.ads) || [];

  useEffect(() => {
    const id = router?.params?.id;
    if (id) dispatch(getProductAds(id));
  }, [dispatch, router?.params?.id]);

  const columns = useMemo(
    () => [
      {
        id: "adsMedia",
        header: "Image",
        cell: ({ row }: AdCellProps) => (
          <div>
            <Media className="align-items-center">
              <img
                className="avatar rounded-circle mr-3"
                src={row.original?.adsMedia}
                alt="Ad Media"
              />
            </Media>
          </div>
        ),
      },
      { accessorKey: "adsTitle", header: "Title" },
      { accessorKey: "adsDescription", header: "Description" },
      { accessorKey: "adsPosition", header: "Position" },
      {
        id: "actions",
        header: "Actions",
        cell: ({ row }: AdCellProps) => (
          <div key={row.original._id}>
            <Button
              color="primary"
              size="sm"
              tag={Link}
              to={`/admin/ads/${row.original._id}`}
            >
              <span className="btn-inner--icon mr-1">
                <i className="ni ni-settings-gear-65" />
              </span>
              View
            </Button>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <>
      <div className="rna-wrapper">
        <ToastContainer />
      </div>
      <DisplayAdsView data={ads} columns={columns} />
    </>
  );
}

export default withRouter(DisplayAdsContainer);
